"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var styles_1 = require("@mui/styles");
var React = require("react");
var useStyles = (0, styles_1.makeStyles)({
    tooltip: {
        color: '#222222',
        backgroundColor: '#dddddd',
        margin: '2px 5px',
    },
});
var StyledTooltip = function (_a) {
    var Icon = _a.Icon, placement = _a.placement, text = _a.text;
    var classes = useStyles();
    if (!text) {
        return React.createElement(Icon, null);
    }
    return (React.createElement(material_1.Tooltip, { title: text, placement: placement, classes: classes },
        React.createElement(Icon, null)));
};
exports.default = StyledTooltip;
//# sourceMappingURL=StyledTooltip.js.map